import {
    hydrate,
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { App } from './App';
import type { AppProps } from './AppProps';
import { loadAndActivateI18n } from './i18n';

const PODLET_NAME = 'search-newfrontier-podlet';

const wrapper = document.querySelector(`${PODLET_NAME}-isolated`);

if (wrapper?.shadowRoot) {
    const data = wrapper.shadowRoot.querySelector(
        `script[type="application/json"]`,
    );
    if (data && data.textContent) {
        try {
            const props: HydratedAppProps = JSON.parse(data.textContent);

            loadAndActivateI18n(props.locale);

            const el = wrapper.shadowRoot.querySelector(`#${PODLET_NAME}`);
            if (el) {
                hydrateRoot(el, React.createElement(HydratedApp, props));
            }
        } catch (err) {
            throw new Error(
                `SSR(hydrate): Props (${
                    data.textContent
                }) were provided but parse failed: Error message was: ${
                    (err as Error).message
                }`,
            );
        }
    }
}

type HydratedAppProps = AppProps & {
    reactQueryState: unknown;
};

function HydratedApp(props: HydratedAppProps) {
    const { reactQueryState, ...appProps } = props;

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
            },
        },
    });

    hydrate(queryClient, reactQueryState);

    return (
        <QueryClientProvider client={queryClient}>
            <App {...appProps} />
        </QueryClientProvider>
    );
}
